export const getTutorialSteps = (isTrial = false) => [
  {
    id: 'company-search',
    title: 'Company Search',
    description: isTrial
      ? 'Start by searching for companies where people work. Type a company name or browse from our suggested categories.'
      : 'Start by searching for companies where alumni work. Type a company name or browse from our suggested categories.',
    placement: 'bottom',
    image: '/thinkingcar.png',
  },
  {
    id: 'filter-options',
    title: 'Role & Location Filters',
    description: isTrial
      ? "Narrow your search by selecting specific roles like 'Software Engineer' or locations like 'Bay Area' to find the most relevant people."
      : "Narrow your search by selecting specific roles like 'Software Engineer' or locations like 'Bay Area' to find the most relevant alumni.",
    placement: 'right',
    image: '/thinkingcar.png',
  },
  {
    id: 'search-button',
    title: 'LinkedIn Integration',
    description: isTrial
      ? "Click 'Search' to open LinkedIn with all your filters applied. This will help you find people at your target companies."
      : "Click 'Search' to open LinkedIn with all your filters applied. This will help you find alumni from your school at your target companies.",
    placement: 'left',
    image: '/thinkingcar.png',
  },
  {
    id: 'coffee-chat-questions',
    title: 'Coffee Chat Resources',
    description: isTrial
      ? "Below the search area, you'll find common coffee chat questions to help guide your conversations. These can help you make the most of your networking opportunities."
      : "Below the search area, you'll find common coffee chat questions to help guide your conversations with alumni. These can help you make the most of your networking opportunities.",
    placement: 'top',
    image: '/thinkingcar.png',
  },
];

// For backwards compatibility, export the default (non-trial) version
export const TUTORIAL_STEPS = getTutorialSteps(false);
